import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './js/firebase';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './fonts/Hideous.ttf'

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();
